// Sanskrit/Indic term glossary for the reader's transliteration panel.
export const GLOSSARY = {
  dharma: { script: "धर्म", def: "Cosmic order, duty, and the law that sustains reality and society." },
  karma: { script: "कर्म", def: "Action and its consequences; the moral law of cause and effect." },
  moksha: { script: "मोक्ष", def: "Liberation — release from the cycle of conditioned existence." },
  mukti: { script: "मुक्ति", def: "Freedom, release; a synonym of moksha." },
  atman: { script: "आत्मन्", def: "The self or innermost essence of a being." },
  brahman: { script: "ब्रह्मन्", def: "The ultimate, unconditioned reality in Vedanta." },
  maya: { script: "माया", def: "Appearance; the creative power that veils and projects the world." },
  samsara: { script: "संसार", def: "The cycle of birth, death, and rebirth." },
  nirvana: { script: "निर्वाण", def: "Extinguishing of craving; the cessation of suffering." },
  dukkha: { script: "दुःख", def: "Suffering, unsatisfactoriness — the first of the Noble Truths." },
  ahimsa: { script: "अहिंसा", def: "Non-harm; the ethic of causing the least injury to living beings." },
  yoga: { script: "योग", def: "Discipline of uniting or stilling the mind." },
  pramana: { script: "प्रमाण", def: "A valid means of knowledge — perception, inference, testimony." },
  shakti: { script: "शक्ति", def: "Power, energy; the active, feminine principle of reality." },
  shiva: { script: "शिव", def: "The auspicious one; consciousness as pure awareness." },
  kali: { script: "काली", def: "The goddess of time and transformation." },
  tantra: { script: "तन्त्र", def: "Ritual and contemplative systems using mantra, yantra, and the body." },
  mantra: { script: "मन्त्र", def: "A sacred sound or formula used in meditation and ritual." },
  yantra: { script: "यन्त्र", def: "A geometric diagram used as a meditative instrument." },
  mandala: { script: "मण्डल", def: "A sacred circle or cosmogram." },
  guru: { script: "गुरु", def: "A teacher who dispels darkness." },
  bhakti: { script: "भक्ति", def: "Loving devotion to the divine." },
  jnana: { script: "ज्ञान", def: "Knowledge, especially liberating insight." },
  vidya: { script: "विद्या", def: "Knowledge or wisdom." },
  avidya: { script: "अविद्या", def: "Ignorance; not seeing clearly." },
  purusha: { script: "पुरुष", def: "Pure consciousness in Samkhya dualism." },
  prakriti: { script: "प्रकृति", def: "Primordial nature or matter in Samkhya." },
  tapas: { script: "तपस्", def: "Ascetic heat; disciplined effort." },
  seva: { script: "सेवा", def: "Selfless service." },
  sangha: { script: "संघ", def: "The community of practitioners." },
  buddha: { script: "बुद्ध", def: "The awakened one." },
  bodhi: { script: "बोधि", def: "Awakening, enlightenment." },
  anatta: { script: "अनात्ता", def: "Non-self; the absence of a fixed, separate self." },
};

export const LANGUAGES = [
  { code: "original", label: "English (original)", voice: "en-US" },
  { code: "Hindi", label: "हिन्दी · Hindi", voice: "hi-IN" },
  { code: "Bengali", label: "বাংলা · Bengali", voice: "bn-IN" },
  { code: "Tamil", label: "தமிழ் · Tamil", voice: "ta-IN" },
  { code: "Telugu", label: "తెలుగు · Telugu", voice: "te-IN" },
  { code: "Marathi", label: "मराठी · Marathi", voice: "mr-IN" },
  { code: "Gujarati", label: "ગુજરાતી · Gujarati", voice: "gu-IN" },
  { code: "Kannada", label: "ಕನ್ನಡ · Kannada", voice: "kn-IN" },
  { code: "Malayalam", label: "മലയാളം · Malayalam", voice: "ml-IN" },
  { code: "Punjabi", label: "ਪੰਜਾਬੀ · Punjabi", voice: "pa-IN" },
  { code: "Sanskrit", label: "संस्कृतम् · Sanskrit", voice: "hi-IN" },
  { code: "Spanish", label: "Español · Spanish", voice: "es-ES" },
  { code: "French", label: "Français · French", voice: "fr-FR" },
  { code: "German", label: "Deutsch · German", voice: "de-DE" },
  { code: "Arabic", label: "العربية · Arabic", voice: "ar-SA" },
  { code: "Chinese (Simplified)", label: "中文 · Chinese", voice: "zh-CN" },
  { code: "Japanese", label: "日本語 · Japanese", voice: "ja-JP" },
];
